import { Balance } from "@/api/balances"
import { Card, CardContent } from "@/components/ui/card"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel"
import BalanceItem from "./balance-item"

interface BalancesCarouselProps {
  balances: Balance[];
}

export default function BalancesCarousel({ balances }: BalancesCarouselProps) {
  return (
    <Carousel>
      <div className="flex flex-col">
        <div className="flex flex-row justify-between items-center pb-5 flex-grow">
          <h3 className="text-md font-semibold">My Assets</h3>
          <div className="flex flex-row gap-1">
            <CarouselPrevious />
            <CarouselNext />
          </div>
        </div>
        {balances.length === 0 && (
          <div className="flex flex-grow items-center justify-center pt-7">
            <p className="text-gray-300 text-sm">No assets found</p>
          </div>
        )}
        <CarouselContent>
          {balances.map((balance: Balance) => (
            <CarouselItem
              className="lg:basis-1/2 xl:basis-1/3"
              key={`${balance.network}-${balance.token}`}
            >
              <Card key={balance.token} className="flex-grow">
                <CardContent>
                  <BalanceItem balance={balance} />
                </CardContent>
              </Card>
            </CarouselItem>
          ))}
        </CarouselContent>
      </div>
    </Carousel>
  )
}
